import script from "./goodsList.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsList.vue?vue&type=script&setup=true&lang=js"

import "./goodsList.vue?vue&type=style&index=0&id=cbd5a7ee&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbd5a7ee"]])

export default __exports__